import React from "react";
import { Route } from "react-router";
import FoodPage from "./FoodPage";

const RouterFoods = () => {
  return <Route exact path="/foods/:id?" name="Food" component={FoodPage} />;
};

export default RouterFoods;
